import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { combineLatest } from 'rxjs'
import { MeetingsService } from '../meetings.service'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { ToastService } from '../toast.service'

@Component({
  selector: 'app-hang-up-page',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './hang-up-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './hang-up-page.component.scss',
})
export class HangUpPageComponent implements OnInit {
  route = inject(ActivatedRoute)
  meetingsService = inject(MeetingsService)
  dialog = inject(MatDialog)
  translateService = inject(TranslateService)
  toastService = inject(ToastService)

  success = false

  currentMeetingId = parseInt(this.route.snapshot.params['id'], 10)
  accessKey = this.route.snapshot.queryParams['access-key']

  async ngOnInit(): Promise<void> {
    this.translateService.use('en').subscribe(() => {
      this.hangUpMeeting()
    })
  }

  async hangUpMeeting() {
    combineLatest([
      this.translateService.get('MEETINGS.HANG_UP.DIALOG_TITLE'),
      this.translateService.get('MEETINGS.HANG_UP.DIALOG_BODY_ANONYMOUS'),
      this.translateService.get('COMMON.YES'),
    ]).subscribe(([title, description, confirmLabel]) => {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title,
          description,
          confirmLabel,
        },
      })

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.meetingsService.hangUpMeetingAnonymously(this.currentMeetingId, this.accessKey).subscribe((success) => {
            this.success = success
          })
        }
      })
    })
  }
}
